'use strict';
var $ = require('jquery');

function updateHtml(selector, $newData) {
	var $new = $(selector, $newData);
	if ($new.length > 0) {
		var $old = $(selector);
		$old.html($new.html());
	}
}

function init() {
	$('main').on('click', '.siblingLocalNav__link a[data-opentab="true"]', function (event) {
		event.preventDefault();

		var $this = $(this);
		var href = $this.attr('href');

		var $section__content = $this.closest('.section__content');

		// Marker class to denote loading taking place
		$section__content.addClass('section__content--isLoading');

		$.ajax({
			url: href
		})
		.done(function (data, textStatus, jqXHR) {
			var $data = $(data);

			// Update content
			//updateHtml('.intro', $data);
			updateHtml('.section__contentInner:first', $data);

			// Change active tab
			$('.siblingLocalNav__link--active').removeClass('siblingLocalNav__link--active');
			$this.closest('.siblingLocalNav__link').addClass('siblingLocalNav__link--active');

			// Change location bar and title of page
			if (history !== undefined) {
				var title = $('title', $data).text();
				history.pushState(undefined, title, href);
			}
		})
		.fail(function(jqXHR, textStatus, errorThrown) {
			// Error
			console.error(errorThrown);
		})
		.always(function() {
			// No longer waiting for remove class
			window.requestAnimationFrame(function() {
				$section__content.removeClass('section__content--isLoading');
			});
		})
		;
	});
}

module.exports = {
	init : init
};
